/* eslint-disable import/no-extraneous-dependencies */
import { ExcelExport } from "@progress/kendo-react-excel-export";
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui";
import { formatDate } from "date-fns";
import { DownloadCloud } from "lucide-react";
import React, { useEffect } from "react";
import {
  useGetAEDTemplate,
  useGetSmallDenominationsTemplate,
} from "utils/apis/kiosk.api";

export default function DownloadTemplate({
  operationDate,
}: {
  operationDate?: Date;
}) {
  let excelExport1: ExcelExport | null;
  let excelExport2: ExcelExport | null;

  const {
    mutate: getSmallDenominationsTemplate,
    data: smallDenominationsTemplateData,
  } = useGetSmallDenominationsTemplate();
  const { mutate: getAEDTemplate, data: AEDTemplateData } = useGetAEDTemplate();

  const onDownloadTemplate = (type: string) => {
    if (type === "Small Denominations") {
      getSmallDenominationsTemplate({
        operationDate: formatDate(
          operationDate || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
      });
    } else if (type === "AED & Coins") {
      getAEDTemplate({
        operationDate: formatDate(
          operationDate || new Date(),
          "yyyy-MM-dd'T'00:00:00.000'Z'",
        ),
      });
    }
  };

  useEffect(() => {
    if (smallDenominationsTemplateData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      excelExport1?.save(smallDenominationsTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [smallDenominationsTemplateData]);

  useEffect(() => {
    if (AEDTemplateData) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      excelExport2?.save(AEDTemplateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AEDTemplateData]);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="gap-2">
            <DownloadCloud /> Download Templates
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="w-[180px]">
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("Small Denominations");
            }}
            className="cursor-pointer"
          >
            Small Denominations
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              onDownloadTemplate("AED & Coins");
            }}
            className="cursor-pointer"
          >
            AED & Coins
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <ExcelExport
        ref={(exporter) => {
          excelExport1 = exporter;
        }}
        fileName={`Kiosk_Small_Denominations_Bags_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Cash Center Barcode" },
          { field: "onwardBarcode", title: "Location Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "bagType", title: "Bag Type" },
          { field: "currency", title: "Currency" },
          { field: "denomination", title: "Denomination" },
          { field: "notes", title: "Notes" },
        ]}
      />
      <ExcelExport
        ref={(exporter) => {
          excelExport2 = exporter;
        }}
        fileName={`Kiosk_AED_&_Coins_Assignment_${new Date().toDateString()}.xlsx`}
        columns={[
          { field: "serviceDate", title: "Service Date" },
          { field: "routeNo", title: "Route No" },
          { field: "sourceBarcode", title: "Cash Center Barcode" },
          { field: "onwardBarcode", title: "Location Barcode" },
          { field: "sealNo", title: "Seal No" },
          { field: "bagType", title: "Bag Type" },
          { field: "value", title: "Value" },
          { field: "denom1", title: "AED 1 Coins" },
          { field: "denom2", title: "AED 0.5 Coins" },
          { field: "denom3", title: "AED 0.25 Coins" },
        ]}
      />
    </>
  );
}
